

<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>ADD NEW ZONE</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings">
      <div class="p-6">
        <!-- NAME -->
        <div class="mt-1">
          <gmap-map
            :center="coordinates"
            :zoom="zoom"
            map-type-id="terrain"
            style="min-width: 200px; min-height: 400px;width:100%"
          >
            <gmap-marker
              :position="coordinates"
              :clickable="true"
              :draggable="true"
              @click="center=latLng"
            ></gmap-marker>
          </gmap-map>
        </div>
        <gmap-autocomplete
          class="vs-inputx vs-input--input normal"
          style="width: 100%;border: 1px solid rgba(0, 0, 0, 0.2);margin-top: 1.25rem !important;"
          :placeholder="placeholder"
          :value="address"
          @place_changed="setPlace"
          :select-first-on-enter="true"
        ></gmap-autocomplete>
        <vs-input
          label="Zone Name"
          v-validate="'required|regex:^[a-zA-Z0-9 ]*$|min:3|max:24'"
          data-vv-validate-on="blur"
          name="Name"
          v-model="name"
          class="mt-5 w-full"
        />
        <span class="text-danger text-sm">{{ errors.first('Name') }}</span>

        <!-- CATEGORY -->
        <h6 class="mt-5">Select State</h6>
        <v-select
          @change="makeDistrictList"
          class="w-full"
          v-model="selectedState"
          :options="availableStates"
          :clearable="false"
        ></v-select>
        <h6 class="mt-5">Select District</h6>
        <v-select
          class="w-full"
          v-model="selectedDistrict"
          :clearable="false"
          :options="availableDistricts"
        ></v-select>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center p-6" slot="footer">
      <vs-button class="mr-6" :disabled="!validateForm" @click="addZone">Add Zone</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import districtData from "./districts.json";
import vSelect from "vue-select";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      name: "",
      staeWiseData: districtData,
      endpoint: this.$store.state.endpoint2,
      availableStates: [],
      selectedState: { label: "West Bengal", value: "West Bengal" },
      availableDistricts: [],
      selectedDistrict: { label: "Kolkata", value: "Kolkata" },
      address: "",
      placeholder: "Enter Zone Address",
      latLng: { lat: 22.572646, lng: 88.36389499999996 },
      center: { lat: 22.572646, lng: 88.36389499999996 },
      coordinates: {
        lat: 22.572646,
        lng: 88.36389499999996
      },
      zoom: 15,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },
  created() {
    var data = this.staeWiseData;
    var states = [];
    for (var m in data) {
      states.push(m);
    }
    states = states.sort();
    var stateList = [];
    for (var x in states) {
      stateList.push({ label: states[x], value: states[x] });
    }
    this.availableStates = stateList;
    var selectedDistrictList = data[this.selectedState];
    var districtList = [];
    for (var y in selectedDistrictList) {
      districtList.push({
        label: selectedDistrictList[y],
        value: selectedDistrictList[y]
      });
    }
    this.availableDistricts = districtList;
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        console.log(val);
        if (!val) {
          this.$emit("closeSidebar");
          this.initValues();
        }
      }
    },
    validateForm() {
      return !this.errors.any() && this.name != "" && this.address != "";
    }
  },
  methods: {
    initValues() {
      this.name = "";
      this.selectedState = { label: "West Bengal", value: "West Bengal" };
      this.selectedDistrict = { label: "Kolkata", value: "Kolkata" };
      this.address = "";
      this.coordinates = {
        lat: 22.572646,
        lng: 88.36389499999996
      };
    },
    makeDistrictList() {
      var selectedState = this.selectedState.value;
      var data = this.staeWiseData;
      var selectedDistrictList = data[selectedState];
      var districtList = [];
      for (var y in selectedDistrictList) {
        districtList.push({
          label: selectedDistrictList[y],
          value: selectedDistrictList[y]
        });
      }
      this.availableDistricts = districtList;
      this.selectedDistrict = districtList[0];
    },
    setPlace(place) {
      this.address = place.formatted_address;

      this.coordinates = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
    },
    addZone() {
      let zoneName = this.name;
      var payload = {
        clientId: this.$store.state.userInfo.id,
        name: zoneName.trim(),
        address: this.address,
        lat: this.coordinates.lat,
        lng: this.coordinates.lng,
        insideState: this.selectedState.value,
        district: this.selectedDistrict.value
      };
      this.$http
        .post(this.endpoint + "/addzone", payload)
        .then(response => {
          this.initValues();
          this.$vs.notify({
            title: "Zone Created",
            text: "Your zone is successfully registered!",
            iconPack: "feather",
            icon: "icon-check",
            color: "success"
          });
          const payload = {
            clientId: this.$store.state.userInfo.id,
            notify: this.$vs.notify
          };
          this.$store.dispatch("getZoneData", payload);
          this.isSidebarActiveLocal = false;
        })
        .catch(error => {
          this.$vs.notify({
            title: "Error",
            text: error.response.data,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        });
    }
  },
  components: {
    VuePerfectScrollbar,
    "v-select": vSelect
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}
</style>
<style>
.pac-container {
  z-index: 52010 !important;
}
</style>

